/*
 * @flow
 */
import React from 'react';
import { Spinner } from 'sarsaparilla';
import PublicReview from './PublicReview';
import type { publicReview } from '../model/publicReview';

type PropTypes = {
  reviews: Array<publicReview>,
  displayLength: number,
  loading: number,
  flagReview: Function,
  voteReview: Function,
};

export default class LocationReviews extends React.PureComponent<PropTypes> {
  render() {
    const { loading, reviews, displayLength, flagReview, voteReview } = this.props;
    if (!reviews.length) {
      return <div className="location-reviews-wrapper">No reviews to display.</div>;
    }
    return (
      <div className="location-reviews-wrapper">
        {reviews.slice(0, displayLength).map((review) => (
          <PublicReview
            review={review}
            key={`review-${review.reservation_id}`}
            flagReview={flagReview}
            voteReview={voteReview}
          />
        ))}
        {loading <= displayLength && <Spinner size="xl" />}
      </div>
    );
  }
}
